export default function validate(amount) {
  const { minimum_amount: min, maximum_amount: max } = amount;
  return max !== undefined && min !== undefined && max >= min && min >= 0;
}
